<!--
  File name: Chart.vue
  Program Description:
    - This component allows you to display bar graphs or pie charts
    according to the passed data.
    - When accessed, it renders the selected chart and sets the colors
    depending on the number of data
    layout
  Includes:
    * Pie
    * Bar Horizontal
    * Bar
-->
<template>
  <div v-if="rendered">
    <h2
      v-if="label"
      class="text-center grey--text text-h6 my-4"
    >
      {{ label }}
    </h2>
    <Pie
      v-if="chartType === 'pie'"
      :chart-data="chartData || data"
      :options="chartOptions"
      :styles="chartStyle"
      :canvas-height="canvasHeight"
    />
    <BarHorizontal
      v-if="chartType === 'barHorizontal'"
      :chart-data="chartData || data"
      :options="chartOptions"
      :styles="chartStyle"
    />
    <Bar
      v-if="chartType === 'bar'"
      :chart-data="chartData || data"
      :options="chartOptions"
      :styles="chartStyle"
      :canvas-height="canvasHeight"
    />
  </div>
</template>

<script>
import Pie from './Pie.vue'
import BarHorizontal from './BarHorizontal.vue'
import Bar from './Bar.vue'
import graphOptions from '@/meta/graphOptions'

export default {
  name: 'Chart',
  components: {
    Pie,
    BarHorizontal,
    Bar
  },
  props: {
    chartType: {
      type: String,
      default: undefined
    },
    chartData: {
      type: Object,
      default: () => {}
    },
    chartOptions: {
      type: Object,
      default: () => {}
    },
    chartStyle: {
      type: Object,
      default: () => {}
    },
    customDesign: {
      type: Boolean,
      default: false
    },
    canvasHeight: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      colors: [...graphOptions('chart').graphColors],
      data: {},
      rendered: true
    }
  },
  computed: {
    randomColor () {
      return qty => [...Array(qty).keys()].map(_ => '#' + Math.floor(Math.random() * 16777215).toString(16))
    }
  },
  watch: {
    chartData () {
      if (!this.customDesign) {
        const data = { ...this.chartData }
        const count = data.labels.length > this.colors.length ? data.labels.length - this.colors.length : 0
        this.colors.push(...this.randomColor(count))
        if (data.datasets && data.datasets.length) {
          const colors = []
          if (data.datasets.length === 1) {
            for (let i = 0; i <= Math.ceil(data.datasets.length / 10); i++) {
              colors.push(...this.colors)
            }
            data.datasets[0].backgroundColor = colors
          }
          this.data = data
        }
      }
      this.reRenderChart()
    }
  },
  methods: {
    async reRenderChart () {
      this.rendered = false
      await this.$nextTick()
      this.rendered = true
    }
  }
}
</script>
